import { useState, useEffect } from "react";
import { Modal, Form, Input } from "antd";
import callApi from "../../constants/API/CallApi";
import { ShowToast, Severty } from "../../helper/toast";
import { getCity, updateCity } from "../../constants/API/API";

const UpdateCity = ({ editVisible, setEditVisible, selectedBelt, refresh }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (selectedBelt) {
      getCity(selectedBelt?._id)
        .then((response) => {
          if (response.status === 200 && response.data) {
            form.setFieldsValue({
              name: response.data?.name
            });
          }
        })
        .catch((err) => {
          ShowToast(err.message || "Failed to fetch belt data", Severty.ERROR);
        });
    }
  }, [selectedBelt, form]);

  const handleOk = async (values) => {
    setLoading(true);
    callApi({
      callback: () => updateCity({ ...values }, selectedBelt?._id),
      onSuccess: ({ message }) => {
        ShowToast(message, Severty.SUCCESS);
        form.resetFields();
        refresh((x) => !x);
        setEditVisible(false);
        setLoading(false);
      },
      onError: (err) => {
        ShowToast(err, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  const handleCancel = () => {
    setEditVisible(false);
    form.resetFields();
  };

  return (
    <Modal
      open={editVisible}
      className="tab_modal"
      title="Update City"
      okText="Update"
      onCancel={handleCancel}
      okButtonProps={{
        form: "update-belt",
        htmlType: "submit",
        loading: loading,
      }}
      width={500}
      destroyOnClose
    >
      <Form
        id="update-belt"
        form={form}
        onFinish={handleOk}
        layout="vertical"
        preserve={false}
      >
        <Form.Item
          name="name"
          label="City Name"
          rules={[{ required: true, message: "City Name is required" }]}
          normalize={(v) => v?.trimStart()}
        >
          <Input placeholder="Enter City Name" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UpdateCity;
